import i18n from '@/lang' // internationalization


const isNull = (rule, value, callback) => {
  if(typeof value == 'string'){
      value =  value.trim() && (value.trim() + '') || ''
  }else{
      value =  value
  }
  if(value==='' || value==null || value==undefined || value.length==0 || value=={}){
    callback(new Error('请输入内容!'));
  }else{
      callback()
  }
}
const validatePhone = (rule, value, callback) => {
    if (!value) {
        callback();
    }else{
      const patter = /^1[3|4|5|6|7|8|9][0-9]{9}$/;;
        // const patter = new RegExp('^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$')
        if (!patter.test(value)) {
        return callback(new Error('请输入正确的手机号码!'))
        } else {
        callback() // 必须有此项回调，否则验证会一直不通过
        }
    }
    
  }
  // 邮箱的正则
  const validateEmail = (rule, value, callback) => {
    if (!value) {
        callback();
    }else{
        const mailbox = new RegExp('^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$')
        if (!mailbox.test(value)) {
          return callback(new Error(i18n.t(`login.inputCorrectEmail`))) 
        } else {
          callback()
        }
    }
    
  }
  // 身份证号
  const validateIdCardNo = (rule, value, callback) => {
    if (!value) {
        callback();
    }else{
        const mailbox = new RegExp(/^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/)
        if (!mailbox.test(value)) {
        return callback(new Error('请输入正确格式的身份证号！'))
        } else {
        callback()
        }
    }
    
  }
  var isTelOrFax = (rule, value, callback) => {//座机/Fax
    if (!value) {
      callback();
    } else {
      const reg = /^(\d{3,4}-)?\d{7,8}$/;
      const isTel = reg.test(value);
      if (value.length < 10 || value.length > 13 || !isTel ) {//判断传真字符范围是在10到13
        callback(new Error("请正确输入座机号码！"));
      } else {
        callback();
      }
    }
  };
  var isPhoneNo= (rule, value, callback) => {
    if (!value) {
      callback();
    }else{
      const reg = /^(\d{3,4}-)?\d{7,8}$/;
      const patter = new RegExp('^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$')
      const isTel = reg.test(value)

      if (!patter.test(value)) {
        if (value.length < 10 || value.length > 13 || !isTel ) {//判断传真字符范围是在10到13
          callback(new Error("请正确输入手机号或座机号码！"));
        } else {
          callback();
        }
      } else {
        callback() // 必须有此项回调，否则验证会一直不通过
      }
    }
  }
  var isPhoneTel= (rule, value, callback) => {
    if (!value) {
      callback();
    }else{
      const reg = /^(\d{3,4}-)?\d{7,8}$/;
      const patter = new RegExp('^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$')
      const isTel = reg.test(value)

      if (!patter.test(value)) {
        if (value.length < 10 || value.length > 13 || !isTel ) {//判断传真字符范围是在10到13
          callback(new Error("请正确输入手机号或座机号码！"));
        } else {
          callback();
        }
      } else {
        callback() // 必须有此项回调，否则验证会一直不通过
      }
    }
  }
  export default {
    common: {
        isNull:[//非空验证
            { validator: isNull, trigger: ['blur','change'] }
        ],
        phone: [// 手机号
            { validator: validatePhone, trigger: 'blur' }
        ],
        mustPhone: [// 手机号必填
          { validator: isNull, trigger: ['blur','change'] },
          { validator: validatePhone, trigger: 'blur' }
        ],
        email: [// 邮箱
            { validator: validateEmail, trigger: ['blur','change']  }
        ],
        mustEmail: [// 邮箱 必填
            { validator: isNull, trigger: ['blur','change'] },
            { validator: validateEmail, trigger: ['blur','change']  }
        ],
        idCardNo: [// 身份证号码
            { validator: validateIdCardNo, trigger: 'blur' }
        ],
        FaxPhone:[//座机/Fax
            { validator: isTelOrFax, trigger: 'blur' }
        ],
        TelPhone:[//座机/Fax必填
          { required: true, message: '请输入座机号码', trigger: ['blur','change'] },
          { validator: isTelOrFax, trigger: 'blur' }
        ],
        mobileFax:[//座机&手机必填
          { required: true, message: '请输入手机或座机号码', trigger: ['blur','change'] },
          { validator: isPhoneNo, trigger: 'blur' }
        ],
        mobileTel:[//座机&手机非必填
          { validator: isPhoneTel, trigger: 'blur' }
        ],
    },
  }